<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="应收退款单详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="refundNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate
          :current="detailInfo"
          @success="handleOperateStateResults"
        />
      </div>
      <div v-loading="loading">
        <div class="main-cont">
          <div class="detail-title-name">
            {{detailInfo.businessName || '-'}}
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="_setStatusColor(detailInfo.approvalStatus, 'approvalStatus')"
                :status="detailInfo.approvalStatusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo">
                <template #refundReason>
                  <jr-tooltip :content="detailInfo.refundReason || '-'" />
                </template>
                <template #rejectReason>
                  <jr-tooltip :content="detailInfo.rejectReason || '-'" />
                </template>
              </jr-col>
              <jr-col :data-show="secondCol" :data="detailInfo" />
              <jr-col :data-show="thirdCol" :data="detailInfo" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联应收单信息</h2>
            <jr-table
              size="mini"
              :tableData="detailInfo.receiveList || []"
              :tableColumn="receiveTableColumn"
            />
          </div>

          <div class="main-cont-item">
            <!-- 对应的是应收单的采购商退款列表 -->
            <h2 class="title-text">应收单关联退款付款单记录</h2>
            <jr-table
              size="mini"
              :tableData="detailInfo.refundList || []"
              :tableColumn="refundTableColumn"
            />
          </div>
        </div>
      </div>
    </finance-drawer>

    <!-- 付款单详情 -->
    <payment-detail
      v-if="isPaymentDetailShow"
      :visible.sync="isPaymentDetailShow"
      :payment-no.sync="paymentNo"
    />
  </div>
</template>
<script>
import { getRefundDetail } from '@/api/approval/refund';
import { setStatusColor } from '@/filters/index';
import paymentDetail from '../../../receivables/payment/components/detail'; // 付款单详情
import btnsOperate from './btns-operate';

export default {
  props: {
    refundNo: {
      type: String,
      default: '',
    },
  },
  components: { paymentDetail, btnsOperate },
  data() {
    return {
      detailInfo: {},
      loading: false,
      isReceiveDetailShow: false, // 应收单详情弹窗
      isPaymentDetailShow: false, // 付款单详情弹窗
      receiveNo: '', // 应收单编号
      paymentNo: '', // 付款单编号
      // 基础信息
      firstCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '服务商名称:', prop: 'payeeBusinessName' },
        { label: 'BD:', prop: 'bdName' },
        { label: '退款原因:', prop: 'refundReason', slotName: 'refundReason' },
        { label: '退款驳回原因:', prop: 'rejectReason', slotName: 'rejectReason' },
      ],
      secondCol: [
        { label: '本次退款金额:', prop: 'refundAmount', filters: 'toFenThousandsAndFloat', className: 'detail-amount_num' },
        { label: '退款总额:', prop: 'refundSumAmount', filters: 'toFenThousandsAndFloat' },
        { label: '应收总额:', prop: 'shouldRecAmount', filters: 'toFenThousandsAndFloat' },
        { label: '实收金额:', prop: 'realAmount', filters: 'toFenThousandsAndFloat' },
      ],
      thirdCol: [
        { label: '申请人:', prop: 'cruser' },
        { label: '申请时间:', prop: 'crtime', filters: 'formatTime' },
        { label: '操作人:', prop: 'approvalUser' },
        { label: '审核时间:', prop: 'approvalTime', filters: 'formatTime' },
      ],
      receiveTableColumn: [
        {
          label: '应收单编号',
          prop: 'receiveNo',
        }, {
          label: '业务订单编号',
          prop: 'orderNumber',
        }, {
          label: '创建时间',
          prop: 'crtime',
          filterName: 'formatTime',
        }, {
          label: '应收总额',
          prop: 'shouldRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '实收总额',
          prop: 'realAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '已确认金额',
          prop: 'confirmAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '待确认金额',
          prop: 'waitConfirmAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '待收金额',
          prop: 'waitRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '退款总额',
          prop: 'refundAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
      ],
      refundTableColumn: [
        {
          label: '付款单编号',
          prop: 'paymentNo',
          permission: 'FWS-SFKGL-FKD-XQ',
          click: (row) => {
            this.handlePaymentDetai(row);
          },
        }, {
          label: '创建时间',
          prop: 'crtime',
          filterName: 'formatTime',
        }, {
          label: '退款方式',
          prop: 'refundTypeDesc',
        }, {
          label: '付款渠道',
          prop: 'payChannelDesc',
        }, {
          label: '退款金额',
          prop: 'refundAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '状态',
          status: 'refundStatus',
          statusDesc: 'refundStatusDesc',
          statusColor: (val) => this._setStatusColor(val, 'paymentStatus'),
        },
      ],
    };
  },
  watch: {
    refundNo: {
      deep: true,
      handler() {
        if (this.refundNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    _setStatusColor(val, type) {
      return setStatusColor(val, type);
    },
    // 收款单确认/取消确认操作返回结果
    handleOperateStateResults() {
      this.getRefundDetail(this.refundNo);
      this.$emit('after-done');
    },
    // 付款单详情
    handlePaymentDetai(row) {
      this.paymentNo = row?.paymentNo || '';
      this.isPaymentDetailShow = true;
    },
    // 应收单详情
    handleReceiveDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isReceiveDetailShow = true;
    },
    handlePictureCardPreview(file, index, gallery) {
      const viewer = this.$refs[gallery].$viewer;
      viewer.view(index);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.detailInfo = {};
        this.isReceiveDetailShow = false;
        this.isPaymentDetailShow = false;
        this.getRefundDetail(this.refundNo);
      });
    },

    // 获取详情接口
    getRefundDetail(refundNo) {
      if (!this.refundNo) {
        this.$message({
          message: '收款退款单编号不能为空！！',
          type: 'warning',
        });
        return;
      }
      this.loading = true;
      getRefundDetail({ refundNo }).then((res) => {
        this.detailInfo = res.data || {};
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.table-button {
  margin-bottom: 0;
}
</style>

